import { PlusOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { useGetUsersByIds } from '@/modules/admin/hooks/useUser';
import { getNameInitial } from '@/utils/utils';

const RenderGroup = ({ size, maxCount, users, ...props }) =>
  <Avatar.Group
    size={size}
    maxCount={maxCount}
    maxStyle={{
      color: '#909090',
      backgroundColor: '#ffffff',
      border: '1px solid #f0f0f0'
    }}
    {...props}
  >
    {users.map(({ avatar, fullName }, i) => <Avatar
      key={i}
      src={avatar}
    >
      {!avatar && fullName && getNameInitial(fullName)}
    </Avatar>)}
  </Avatar.Group>;

RenderGroup.propTypes = {
  users: PropTypes.array,
  size: PropTypes.string,
  maxCount: PropTypes.number,
};

RenderGroup.defaultProps = {
  users: [],
};

const GroupFromServer = ({ users, ...rest }) => {
  const { isLoading, data } = useGetUsersByIds(users);
  
  if (!data || isLoading) return <Skeleton.Avatar active={false}/>;
  
  return <RenderGroup users={data} {...rest} />;
};

GroupFromServer.propTypes = {
  users: PropTypes.array
};

const AvatarGroup = ({ dataById, users, dynamic, ...props }) => {
  if (!users || users?.length < 1)
    return <Avatar
      className={'text-xs text-black'}
      icon={dynamic ? <PlusOutlined/> : <UserOutlined/>}
      size={'default'}
    />;
  
  if (dataById) return <GroupFromServer users={users} {...props}/>;
  
  return <RenderGroup users={users} {...props}/>;
};

AvatarGroup.propTypes = {
  users: PropTypes.array,
  size: PropTypes.string,
  maxCount: PropTypes.number,
  dataById: PropTypes.bool,
  dynamic: PropTypes.bool,
};

AvatarGroup.defaultProps = {
  size: 'default',
  maxCount: 3,
  dataById: true,
  dynamic: true,
};

export default memo(AvatarGroup);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} users this is the row instance
 * */
export const renderMembers = (text, { members }) => {
  if (!members || members?.length < 1) return;
  
  const users = members?.map(({ user }) => user);
  
  return (
    <AvatarGroup maxCount={8} users={users}/>
  );
};
